import { i18n } from '@tasama/i18n';
import type { ApiError } from '@tasama/api-client-query';

/**
 * Resolves a BE ApiError to a translated message.
 *
 * Resolution order:
 *   1. error.key — a BE-supplied i18n key in "namespace:path.to.key" format
 *      (e.g. "portal:errors.notifications.fetchFailed"). i18next returns the
 *      translated string when found, or the key itself as fallback — never the
 *      raw BE message.
 *   2. fallback — caller-supplied default string.
 *   3. common:errors.genericError — last-resort generic message.
 */
export function resolveApiErrorMessage(
  error: ApiError,
  fallback?: string
): string {
  if (error.key) {
    return i18n.t(error.key, { defaultValue: error.key });
  }

  return fallback || i18n.t('errors.genericError', { ns: 'common' });
}
